import React, { useState } from "react";
import "./SettingsPage.css";
import { ScenariosPage } from "./ScenariosPage";
import { ContentPage } from "./ContentPage";
import { ScoringConfigPage } from "./ScoringConfigPage";
import { UsersPage } from "./UsersPage";
import { Breadcrumb } from "../shared/Breadcrumb";

const TABS = [
  { id: "scenarios", label: "Scenarios", icon: "🎬" },
  { id: "scoring", label: "Scoring", icon: "📊" },
  { id: "content", label: "Content", icon: "📦" },
  { id: "users", label: "Users & Teams", icon: "👤" },
] as const;

type TabId = typeof TABS[number]["id"];

export function SettingsPage() {
  const [activeTab, setActiveTab] = useState<TabId>("scenarios");

  const activeLabel = TABS.find((t) => t.id === activeTab)?.label || "";

  return (
    <div className="protrain-settings">
      <Breadcrumb items={[
        { label: "Settings", path: "/settings" },
        { label: activeLabel },
      ]} />
      <h2 className="protrain-settings-title">Settings</h2>
      <div className="protrain-settings-tabs">
        {TABS.map((tab) => (
          <button
            key={tab.id}
            className={`protrain-settings-tab ${activeTab === tab.id ? "protrain-settings-tab--active" : ""}`}
            onClick={() => setActiveTab(tab.id)}
          >
            <span>{tab.icon}</span>
            <span>{tab.label}</span>
          </button>
        ))}
      </div>
      <div className="protrain-settings-content">
        {activeTab === "scenarios" && <ScenariosPage />}
        {activeTab === "scoring" && <ScoringConfigPage />}
        {activeTab === "content" && <ContentPage />}
        {activeTab === "users" && <UsersPage />}
      </div>
    </div>
  );
}
